// src/types/User.js 
export class User {
  constructor(data) {
    Object.assign(this, {
      id: data.id,
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
      phone: data.phone,
      gender: data.gender,
      role: data.role,
      tag_id: data.tag_id,
      city: data.city, 
      created_at: data.created_at,
      updated_at: data.updated_at
    });
  }
}

export class UserRegistrationData {
  constructor(data) {
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.email = data.email;
    this.password = data.password;
    this.phone = data.phone;
    this.gender = data.gender;
    this.role = 'patient';
    this.tag_id = data.tag_id;
    this.otp = data.otp;
    this.city = data.city || ''; 
  }
}